// Ionic
import { alertController } from '@ionic/vue';

// Vue
import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';

// メモった！、キニッタ！共通スクリプト
import * as GFunc from '@/components/00/Common00';  // 共通メソッド

const routes: Array<RouteRecordRaw> = [

  //
  // メモった！キニッタ！共通画面
  //
  {
    // アカウント新規作成ページ
    path: '/S00001001',
    name: 'S00001001',
    component: () => import('@/components/00/S00001001Page.vue')
  },
  {
    // アカウント新規作成ヘルプページ
    path: '/S00001001/help',
    name: 'S00001001help',
    component: () => import('@/components/00/S00001001Help_ja.vue')
  },
  {
    // アカウント作成確認ページ
    path: '/S00001002',
    name: 'S00001002',
    component: () => import('@/components/00/S00001002Page.vue')
  },
  {
    // プロフィール変更ページ
    path: '/S00001003',
    name: 'S00001003',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/components/00/S00001003Page.vue')
  },
  {
    // パスワード変更ページ
    path: '/S00001004',
    name: 'S00001004',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/components/00/S00001004Page.vue')
  },
  {
    // アカウント削除ページ
    path: '/S00001005',
    name: 'S00001005',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/components/00/S00001005Page.vue')
  },
  {
    // お問い合わせページページ
    path: '/S00001006',
    name: 'S00001006',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/components/00/S00001006Page.vue')
  },
  {
    // アカウント情報表示ページ
    path: '/S00001007',
    name: 'S00001007',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/components/00/S00001007Page.vue')
  },
  {
    // ログアウトページ
    path: '/S00001008',
    name: 'S00001008',
    component: () => import('@/components/00/S00001008Page.vue')
  },
  {
    // お知らせ表示ページ
    path: '/S00001012',
    name: 'S00001012',
    component: () => import('@/components/00/S00001012Page.vue')
  },
  {
    // 入力項目選択ページ
    path: '/S00001014',
    name: 'S00001014',
    component: () => import('@/components/00/S00001014Page.vue')
  },
  {
    // 地図全画面表示ページ(iOSのみ）
    path: '/S00001015',
    name: 'S00001015',
    component: () => import('@/components/00/S00001015Page.vue')
  },

  //
  // キニッタ！グルメ専用画面
  //
  {
    // 初期表示ページ(PCの初期画面、スマフォの自動ログインなしの場合の初期画面)
    path: '/',
    component: () => import('@/views/05/S05001001Page.vue') // 飲食店検索ページ
  },
  {
    // ログインページ
    path: '/S05001000',
    name: 'S05001000',
    component: () => import('@/views/05/S05001000Page.vue')
  },
  {
    // 飲食店検索ページ
    path: '/S05001001',
    name: 'S05001001',
    component: () => import('@/views/05/S05001001Page.vue')
  },
  {
    // 飲食店登録/変更ページ
    path: '/S05001002',
    name: 'S05001002',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/views/05/S05001002Page.vue')
  },  
  {
    // お店ホームページ
    path: '/S05001003',
    name: 'S05001003',
    props: true,
    component: () => import('@/views/05/S05001003Page.vue')
  },
  {
    // お店ホームページ(PCからの直接表示用)
    path: '/S05001003/:parameters',
    component: () => import('@/views/05/S05001003Page.vue')
  },    
  {
    // 感染対策状況の評価ページ 
    path: '/S05001004',
    name: 'S05001004',
    component: () => import('@/views/05/S05001004Page.vue')
  },
  {
    // デイリーカレンダーページ
    path: '/S05001005',
    name: 'S05001005',
    component: () => import('@/views/05/S05001005Page.vue')
  },
  {
    // お気に入りページ
    path: '/S05001006',
    name: 'S05001006',
    component: () => import('@/views/05/S05001006Page.vue')
  },
  {
    // 会員登録ページ
    path: '/S05001007',
    name: 'S05001007',
    component: () => import('@/views/05/S05001007Page.vue')
  },
  // {
  //   // 会員登録ページ(URL、QRからの直接表示用)
  //   path: '/S05001007/:parameters',
  //   component: () => import('@/views/05/S05001007Page.vue')
  // }, 
  {
    // イベント詳細表示ページ
    path: '/S05001008',
    name: 'S05001008',
    component: () => import('@/views/05/S05001008Page.vue')
  },
  {
    // イベント詳細表示ページ(URLからの直接表示用)
    path: '/S05001008/:parameters',
    component: () => import('@/views/05/S05001008Page.vue')
  },
  {
    // 本登録についてページ
    path: '/S05001009',
    name: 'S05001009',
    component: () => import('@/views/05/S05001009Page.vue')
  },
  {
    // 通報ページ
    path: '/S05001010',
    name: 'S05001010',
    component: () => import('@/views/05/S05001010Page.vue')
  },
  {
    // フォトギャラリーページ
    path: '/S05001011',
    name: 'S05001011',
    component: () => import('@/views/05/S05001011Page.vue')
  },
  {
    // マイページ（スマフォの自動ログインありの場合の初期画面）
    path: '/S05001012',
    name: 'S05001012',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/views/05/S05001012Page.vue')
  },
  {
    // キニッタ！インストール方法ページ
    path: '/S05001013',
    name: 'S05001013',
    component: () => import('@/views/05/S05001013Page.vue')
  },
  /* 2024/2/16 会員からポイント利用できない様にこの機能を無効にした
  {
    // ポイント利用ページ
    path: '/S05001014',
    name: 'S05001014',
    meta: { requiredLogin: true }, // ログイン必須    
    component: () => import('@/views/05/S05001014Page.vue')
  },
  */
  {
    // ポイント利用確認ページ
    path: '/S05001015',
    name: 'S05001015',
    meta: { requiredLogin: true }, // ログイン必須    
    component: () => import('@/views/05/S05001015Page.vue')
  },
  {
    // ポイント利用履歴ページ
    path: '/S05001016',
    name: 'S05001016',
    meta: { requiredLogin: true }, // ログイン必須    
    component: () => import('@/views/05/S05001016Page.vue')
  },
  // テスト用(S05001001をコメントアウトして最初に表示する画面をセット)
  // {
  //   path: '/S05001001',
  //   name: 'S05001001',
  //   component: () => import('@/views/05/S05001LoginPage.vue')
  // },
]

// ルータを作成
const router = createRouter({ 
  history: createWebHistory(process.env.BASE_URL),
  routes
})
export default router

/**
 * ログイン必須のエラーを表示する
 */
async function showLoginRequired()
{
  const alert = await alertController.create({
    header: 'Alert',
    message: GFunc.getProperty("msg.2001"),
    buttons: ['OK'],
});
await alert.present();
}

/**
 * ログインチェック
 * ログインしてない場合はログイン画面へ遷移する
 */
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiredLogin)) {
    if (!GFunc.isLoggedin()) {
      showLoginRequired();          // エラーメッセージ表示
      next({ name: 'S05001000' }) // ログイン画面に遷移
    } else {
      next()
    }
  } else {
    next() // next() を常に呼び出すようにする
  }
})


